import { BaseStore } from "@core/base-store";
import { UiService } from "@core/services/ui.services";
import { catchError, first, from, map, of } from "rxjs";

import { Company } from "./company.model";
import CompanyRepository from "./company.repository";

const itemInit: Company = new Company("");
type IState = {
  companies: Company[];
};
const stateInit: IState = {
  companies: [],
};

export class CompanyStore extends BaseStore<IState, Company> {
  constructor(uiService: UiService, private repository: CompanyRepository) {
    super(uiService, stateInit, itemInit);
  }

  loadList() {
    this.ui.loader.show();
    from(this.repository.getAll())
      .pipe(
        catchError(() => of([] as Company[])),
        map(companies => {
          this._state.next({ companies });
          this.ui.loader.hide();
        }),
        first(),
      )
      .subscribe();
  }

  async save() {
    try {
      const model = this.current;
      const entity = Company.build(model);
      if (!entity.id) {
        await this.repository.add(entity);
      } else {
        await this.repository.update(entity.id, entity);
      }
      this.ui.modal.close();
      this.loadList();
    } catch (e: any) {
      this.showValidationMessage(e.message);
    }
  }

  delete(id: string) {
    this.repository.delete(id);
    this.loadList();
  }
}
